import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { User } from '../../../main/content/app/user/user.model';
import { UserProfile } from './profile.model';

@Injectable()
export class UsersService {
    API_URL = environment.apiUrl;

    users: UserProfile[] = [];
    onUserChanged: BehaviorSubject<any> = new BehaviorSubject({});
    onUsersChanged: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private http: HttpClient,
    ) {}

    me() {
        return this.http.get<UserProfile>(`${this.API_URL}/users/me`)/* .subscribe((response: UserProfile) => {
            this.onUserChanged.next(response);
        }) */;
    }

    get(id: string) {
        return this.http.get<UserProfile>(`${this.API_URL}/users/${id}`)/* .subscribe((response: UserProfile) => {
            this.onUserChanged.next(response);
        }) */;
    }

    list() {
        return this.http.get<UserProfile[]>(`${this.API_URL}/users/`).subscribe((response) => {
            this.users = response;
            this.onUsersChanged.next(response);
        });
    }

    create(data: User) {
        return this.http.post<User>(`${this.API_URL}/users/`, data);
    }

    update(id: string, data) {
        return this.http.put<User>(`${this.API_URL}/users/${id}`, data);
    }

    disable(id: string) {
        return this.http.delete<User>(`${this.API_URL}/users/${id}`);
    }

    enable(id: string) {
        return this.http.post<User>(`${this.API_URL}/users/${id}/enable`, {});
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/users/users.service.ts